import styled from '@emotion/styled';
import { Button, Icon, tokens } from '@hotjar/hotsauce';

const Title = styled.h2`
  ${tokens.text('header4')};
  margin-bottom: ${tokens.spacer.x2};
`;

const Description = styled.div`
  max-width: 368px;
`;

const ActionBar = styled.div<{ marginTop?: keyof typeof tokens.spacer }>`
  display: flex;
  justify-content: space-between;
  margin-top: ${(props) =>
    props.marginTop ? tokens.spacer[props.marginTop] : tokens.spacer.x6pt5};
`;

const DownloadButton = styled(Button)`
  margin-right: 8px;
`;

const SuccessWrapper = styled.div`
  color: ${tokens.color.text_success};
  margin-bottom: ${tokens.spacer.x2};
`;

const SuccessIcon = styled(Icon)`
  margin-right: ${tokens.spacer.x1};
`;

const VerificationWrapper = styled.div`
  margin-top: ${tokens.spacer.x5pt5};
`;

export const MfaEnforceEnableMfaPageStyles = {
  Title,
  Description,
  ActionBar,
  DownloadButton,
  SuccessWrapper,
  SuccessIcon,
  VerificationWrapper,
};
